<template>
    <div></div>
</template>
<script>
export default {
    data() {
        return {
            contentMap: {
                '1': {type: 'page'},
                '2': {type: 'page'},
                '3': {type: 'catalog', layout: 'pc'},
                '4': {type: 'catalog', layout: 'pc'},
                '5': {type: 'catalog', layout: 'pc'},
                '6': {type: 'catalog', layout: 'news'},
                '7': {type: 'page'},
                '8': {type: 'page'},
                '9': {type: 'catalog', layout: 'mobile'},
                '10': {type: 'page'}
            }
        }
    },
    methods: {
        initData() {
            // 目录类型
            if (this.$route.query.contentId) {
                this.$http({
                    url: '/v1/content/byId',
                    method: 'get',
                    params: { id: this.$route.query.contentId }
                }).then(res => {
                    this.$changeTitle(res.name)
                    if (res.type === 'catalog') {
                        if (this.contentMap[this.$route.query.contentId].layout === 'pc') {
                            this.$router.replace('/pcView?contentId=' + this.$route.query.contentId)
                        } else if(this.contentMap[this.$route.query.contentId].layout === 'mobile') {
                            this.$router.replace('/clientView?contentId=' + this.$route.query.contentId)
                        } else if(this.contentMap[this.$route.query.contentId].layout === 'news') {
                            this.$router.replace('/newsView?contentId=' + this.$route.query.contentId)
                        }
                    } else if (res.type === 'page') {
                        this.$router.replace('/pageDetail?contentId=' + this.$route.query.contentId)
                    }
                }).catch(err => {
                    console.info(err)
                })
            } else if (this.$route.query.itemId) {
                this.$router.replace('/preview?itemId=' + this.$route.query.itemId)
            } else {
                this.$router.replace('/error')
            }
        }
    },
    mounted() {
        this.initData()
    },
    watch: {
        '$route.path': function(newVal)  {
            if (newVal === '/index') {
                this.initData()
            }
        }
    },
    created() {
        window.addEventListener(
            'hashchange',
            (event) => {
                event.newURL
                const myDomain = window.location.href.substring(0, window.location.href.indexOf(window.location.hash))
                // 本系统页面
                if (event.newURL.startsWith(myDomain)) {
                    const currentPath = window.location.hash.slice(1)
                    if (this.$route.path !== currentPath) {
                        this.$router.push(currentPath)
                    }
                } else {
                    window.location.href = event.newURL
                }
            },
            false
        )
    }
}
</script>


// WEBPACK FOOTER //
// src/views/index.vue